import t from "./highrise1528.mjs";
import a from "./highrise1310.mjs";
var e = t(a, "DataView");
export {
  e as default
};
